import React, { useContext } from "react";
import Accordion from "components/accordion";
import Loader from "components/loader/loader";
import { TaskContext } from "contexts/task";
import { useColumnTemplate } from "shared/hooks/use-column-template";
import { BVQaAttributeSubgroups } from "./bv-qa-attribute-subgroups";
import { BVQaAttributeRow } from "./bv-qa-attribute-row";
import { useAcceptRejectAttribute } from "./hooks/use-accept-reject-attribute";
import { isEmpty } from "lodash";
import { brandVerifiedAttributeStatus } from "../attributes/lib/constants";

export const BvQaAttributeTable = ({
    attributeGroups,
    columnWidths,
    roleLabels,
    codingWipKey,
    viewAllAttributes,
    onAttrList,
    refreshAttributeGroups,
    isCompleted,
}) => {
    const gridTemplate = useColumnTemplate(roleLabels && roleLabels.length + 1, columnWidths, false);
    const { task } = useContext(TaskContext);
    const { mutateAsync: updateAttribute } = useAcceptRejectAttribute();

    const updateAttributeStatus = async (attributeUuid, approvalStatus, note) => {
        return await updateAttribute({ codingWipKey, attributeUuid, approvalStatus, note });
    };

    const accordionGroups =
        attributeGroups &&
        attributeGroups.map(({ groupName, groupLabel, subGroups, attributes }) => {
            if (!isEmpty(subGroups)) {
                const isEverySubgroupAttributeAutoAccepted = subGroups.every((subgroup) =>
                    subgroup.attributes.every(({ additionalInfo }) => additionalInfo?.approvalStatus === brandVerifiedAttributeStatus.AutoAccepted)
                );

                return (
                    <div
                        key={`group${groupName}`}
                        label={groupLabel}
                        anchor={groupName}
                        hidden={viewAllAttributes ? !viewAllAttributes : isEverySubgroupAttributeAutoAccepted}
                    >
                        <div className="product-compare">
                            <BVQaAttributeSubgroups
                                subGroups={subGroups}
                                roleLabels={roleLabels}
                                columnWidths={columnWidths}
                                task={task}
                                gridTemplate={gridTemplate}
                                viewAllAttributes={viewAllAttributes}
                                onUpdateAttribute={updateAttributeStatus}
                                onAttrList={onAttrList}
                                refreshAttributeGroups={refreshAttributeGroups}
                                isCompleted={isCompleted}
                            />
                        </div>
                    </div>
                );
            }

            const isEveryAttributeAutoAccepted = attributes.every(
                ({ additionalInfo }) => additionalInfo?.approvalStatus === brandVerifiedAttributeStatus.AutoAccepted
            );

            return (
                <div
                    key={`group${groupName}`}
                    label={groupLabel}
                    anchor={groupName}
                    hidden={viewAllAttributes ? !viewAllAttributes : isEveryAttributeAutoAccepted}
                >
                    <div className="product-compare">
                        {attributes.map((attr) => {
                            return (
                                <BVQaAttributeRow
                                    key={attr.key}
                                    viewAllAttributes={viewAllAttributes}
                                    attr={attr}
                                    roleLabels={roleLabels}
                                    gridTemplate={gridTemplate}
                                    onUpdateAttribute={updateAttributeStatus}
                                    onAttrList={onAttrList}
                                    refreshAttributeGroups={refreshAttributeGroups}
                                    isCompleted={isCompleted}
                                />
                            );
                        })}
                    </div>
                </div>
            );
        });

    if (!accordionGroups) {
        return <Loader />;
    }

    return (
        <div className="attribute-content">
            <Accordion
                className={`accordion-attributes "-no-indent"`}
                openAll={true}
            >
                {accordionGroups}
            </Accordion>
        </div>
    );
};
